import { render, staticRenderFns } from "./SectionLayout.vue?vue&type=template&id=3be7d007&"
import script from "./SectionLayout.vue?vue&type=script&lang=ts&"
export * from "./SectionLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports